import { toNumber } from 'lodash';
import React from 'react';
import { FinanceResponseData } from '@upstart/harmony/lib/legos/financingTypes';
import { LineItemType } from '../ricFormTypes';
import { formatCurrency, calculateSumValue } from '../ricFormUtils';
import { LineItem as LineItemElement } from '../Components';

const SchemaLineItem = ({
  formElement,
  responseData,
}: {
  formElement: LineItemType;
  responseData: FinanceResponseData;
  fetchResponseWithUpdatedData: (data: Partial<FinanceResponseData>) => void;
}) => {
  const { title, subtitle, value, sumValue, responseDataField } = formElement;

  let strValue;
  if (responseDataField) {
    strValue = formatCurrency(toNumber(responseData?.[responseDataField]));
  } else if (sumValue) {
    strValue = formatCurrency(calculateSumValue(responseData, sumValue));
  } else {
    strValue = value ?? null;
  }

  return <LineItemElement title={title} subtitle={subtitle} value={strValue} />;
};

export default SchemaLineItem;
